import Api from 'api'

const config = {
  baseURL: '/api/app/v1/oauth',
}
const api = new Api(config)

api.fetchClientInfo = ({ ...rest }) => api.get(`/client/info`, { ...rest })

api.tryAuthenticate = ({ ...rest }) => api.post('/authenticate', { ...rest })

export default api
